@if (gridFixtureList && gridFixtureList.length > 0) {
    @for (gridFixture of gridFixtureList; track $index) {
        <div class="favourites-item">
            @if (gridFixture.grid | async; as gridModel) {
                <div class="grid-wrapper">
                    <ms-fixture-list-header [sport]="gridFixture.favouriteFixture.sport" [navigation]="gridFixture.favouriteFixture.tabs">
                    </ms-fixture-list-header>

                    <ms-grid sortingTracking="Competitions" [model]="gridModel" [tracking]="tracking"></ms-grid>

                    <div class="grid-footer ms-active-highlight">
                        <div class="more-events" (click)="goTo(gridModel.sport)">
                            {{ sitecore.event.OpenAll }} {{ gridModel.sport.name }}
                            <span class="live-count"> {{ gridFixture.liveFixturesCount }} </span>
                            <vn-icon name="theme-right" class="icon-right" [size]="isEpcotEnabled ? '16' : '14'"></vn-icon>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
}
